import { withInstall } from '@park-ui/utils'

import PageHeader from './src/page-header.vue'

export const ElPageHeader = withInstall(PageHeader)
export default ElPageHeader

export * from './src/page-header'
